/**
 * Session Timeout Provider Component
 * React component that integrates the session timeout manager with the application
 */

import React, { useEffect } from 'react';
import { sessionTimeoutManager } from '../../services/sessionTimeoutManager';

export interface SessionTimeoutProviderProps {
  children: React.ReactNode;
  /** Timeout duration in minutes (defaults to env variable or 30) */
  timeoutMinutes?: number;
  /** Enable/disable session timeout (defaults to true) */
  enabled?: boolean;
}

/**
 * Provider component that manages session timeout
 * Should be placed high in the component tree, typically in App.tsx
 */
export const SessionTimeoutProvider: React.FC<SessionTimeoutProviderProps> = ({
  children,
  timeoutMinutes,
  enabled = true,
}) => {
  useEffect(() => {
    // Get timeout from props, env variable, or default to 30 minutes
    const timeout =
      timeoutMinutes ||
      (process.env.REACT_APP_ACCESS_TOKEN_EXPIRY_DURATION
        ? parseInt(process.env.REACT_APP_ACCESS_TOKEN_EXPIRY_DURATION, 10)
        : 30);


    // Initialize the timeout manager
    sessionTimeoutManager.initialize({
      timeoutMinutes: timeout,
      enabled: enabled,
    });

    // Cleanup on unmount
    return () => {
      sessionTimeoutManager.stop();
    };
  }, [timeoutMinutes, enabled]);

  return <>{children}</>;
};
